import { render } from "./creationItem.vue?vue&type=template&id=45b62e77&scoped=true"
import script from "./creationItem.vue?vue&type=script&lang=js"
export * from "./creationItem.vue?vue&type=script&lang=js"

import "./creationItem.vue?vue&type=style&index=0&id=45b62e77&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b62e77"]])

export default __exports__